import _defineProperty from "@babel/runtime/helpers/defineProperty";

class UFOLogger {
  constructor() {
    _defineProperty(this, "enabled", false);
  }

  log(...args) {
    // eslint-disable-next-line no-console
    this.enabled && console.log(UFOLogger.UFOprefix, ...args);
  }

  warn(...args) {
    // eslint-disable-next-line no-console
    this.enabled && console.warn(UFOLogger.UFOprefix, ...args);
  }

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

}

_defineProperty(UFOLogger, "UFOprefix", '[ufo🛸]');

export const ufologger = new UFOLogger();
export const ufolog = (...args) => {
  ufologger.log(...args);
};
export const ufowarn = (...args) => {
  ufologger.warn(...args);
};